import React, { useState } from 'react';
import styled from 'styled-components';
import Dropdown from 'components/dropdown/base/Dropdown';
import DropdownContent from 'components/dropdown/partials/DropdownContent';
import SelectButton from '../select/components/SelectButton';
import MultiSelectConfirmButton from './components/MultiSelectConfirmButton';
import MultiSelectOptions from './components/MultiSelectOptions';
import MultiSelectProvider from './components/MultiSelectProvider';
import type IMultiSelectWithConfirm from './shared/types/multiSelectWithConfirm';

const MultiSelectFooter = styled.div`
    padding: 8px 16px 12px 16px;
`;

export default function MultiSelectWithConfirm({
    name,
    value,
    onChange: onConfirm,
    options,
    disabled,
    triggerText,
    confirmText,
    label,
    helperText,
    isInvalid,
    ...restProps
}: IMultiSelectWithConfirm) {
    const [unconfirmedOptions, setUnconfirmedOptions] = useState(value);

    return (
        <Dropdown
            trigger={
                <SelectButton label={label} helperText={helperText} isInvalid={isInvalid} {...restProps}>
                    {triggerText}
                </SelectButton>
            }
            onOutsideClickCallback={() => onConfirm(unconfirmedOptions)}
            disabled={disabled}
        >
            <DropdownContent>
                <MultiSelectProvider
                    name={name}
                    value={unconfirmedOptions}
                    options={options}
                    onChange={setUnconfirmedOptions}
                >
                    <MultiSelectOptions />
                    <MultiSelectFooter>
                        <MultiSelectConfirmButton onClick={() => onConfirm(unconfirmedOptions)}>
                            {confirmText}
                        </MultiSelectConfirmButton>
                    </MultiSelectFooter>
                </MultiSelectProvider>
            </DropdownContent>
        </Dropdown>
    );
}
